const initialState = {
  isWebView: false,
};

const mutations = {
  SET_IS_WEB_VIEW(state, payload) {
    state.isWebView = payload;
  },
};

const actions = {
  SET_IS_WEB_VIEW({ commit }, payload) {
    if (typeof payload === 'boolean') {
      commit('SET_IS_WEB_VIEW', payload);
    }
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  namespaced: true,
};
